import React from 'react';

import Button from '../Button';
import Popup from '../Popup';
import Table from '../Table';
import {frenchLongFormat, frenchMonthFormat} from '../../../utils';
import { TableConfig } from '../../../types/table-config.type';
import { DropdownConfig } from '../../../types/dropdown-config.type';
import { PaginationMetadata } from '../../../types/pagination-metadata.type';

type CalendarTablePopupProps = {
    calendarTablePopupVisible: boolean;
    setCalendarTablePopupVisible: (visible: boolean) => void;
    data: any[];
    date: string;
    type: string;
    tablePopupConfig: TableConfig;
    tablePopupDropdownConfig: DropdownConfig;
    onButtonTablePopupClick: (date: string) => void;
    buttonTitle: string;
    calendarTableLoading: boolean;
    onPageNumberChange: (page: number) => void;
    paginationMetadata: PaginationMetadata | null;
}

const CalendarTablePopup = ({
    calendarTablePopupVisible,
    setCalendarTablePopupVisible,
    data,
    date,
    type,
    tablePopupConfig,
    tablePopupDropdownConfig,
    onButtonTablePopupClick,
    buttonTitle,
    calendarTableLoading,
    onPageNumberChange,
    paginationMetadata
}: CalendarTablePopupProps) => {
    const handleCreateNewTime = () => {
        setCalendarTablePopupVisible(false);
        onButtonTablePopupClick(date);
    };

    return (
        <Popup setView={setCalendarTablePopupVisible} view={calendarTablePopupVisible} width={'90%'}>
            <div className="px-6 pt-3 pb-6 rounded-lg" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', border: '1px solid rgba(0, 0, 0, 0.06)'}}>
                <div className="flex flex-row items-center justify-between">
                    <p
                        className="text-4xl font-bold capitalize"
                        style={{fontFamily: 'DIN Condensed'}}
                    >
                        {type === 'day' ? frenchLongFormat(date) : frenchMonthFormat(date)}
                    </p>
                    <Button onClick={handleCreateNewTime} content={buttonTitle}/>
                </div>
                <div className="mt-8">
                    <Table
                        data={data}
                        tableConfig={tablePopupConfig}
                        dropdownConfig={tablePopupDropdownConfig}
                        loading={calendarTableLoading}
                        onPageNumberChange={onPageNumberChange}
                        paginationMetadata={paginationMetadata}
                    />
                </div>
            </div>
        </Popup>
    );
};

export default CalendarTablePopup;
